import { connect } from 'react-redux'
import * as SubscriptionActions from '../stores/subscriptions/actions';
import SubscriptionComponent from '../components/subscription';

const mapStateToProps = (state) => {
  return {
    subscription: state.default.subscription
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSubscribe: (cardToken) => {
      dispatch(SubscriptionActions.subscribe(cardToken));
    },
    onResetSubscriptionError: () => {
      dispatch(SubscriptionActions.resetError());
    },
    onPopupMobilePaymentOptions: () => {
      dispatch(SubscriptionActions.tellMobileAppToPopupPaymentOptions());
    },
    onNotifyOnSubscriptionPage: () => {
      dispatch(SubscriptionActions.notifyOnSubscriptionPage());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionComponent);



// WEBPACK FOOTER //
// ./src/containers/subscription.js